import { InvestmentOption } from './investmentOption';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';

export class Simulation {
	investValue: number;
	investTime: number;
	option: InvestmentOption;
	investmentOptionsList: Array<InvestmentOption>;
	message: string;
	success: boolean;
	resumeList: Array<ListItem>;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/models/simulation.ts